import { render } from "./CreateExternalUser.vue?vue&type=template&id=58f211ba&scoped=true&ts=true"
import script from "./CreateExternalUser.vue?vue&type=script&lang=ts"
export * from "./CreateExternalUser.vue?vue&type=script&lang=ts"

import "./CreateExternalUser.vue?vue&type=style&index=0&id=58f211ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f211ba"]])

export default __exports__